import { useMutation, useQueries, useQuery } from 'react-query'
import axios from 'axios'
import {
  InsurerDiscount,
  InsuranceParamsVehiclePagedQuery,
  InsuranceParamsPagedGrid,
  IndividualDiscount,
  InsuranceBase,
  InsuranceParamsPagedQuery,
} from 'BrokerTsLib/src/dtos'
import { baseUrl, GenericQueryOptions } from '.'
import { useApp } from './useApp'
import { Product } from 'BrokerTsLib/src/enums'

const insuranceParamsApiUrl = process.env.REACT_APP_INSURANCEPARAMS_API
const url = `${baseUrl}/${insuranceParamsApiUrl}`

const apiUrl = process.env.REACT_APP_INSURANCEPARAMS_API
const apiTravelUrl = process.env.REACT_APP_INSURANCEPARAMSTRAVEL_API
const apiPropertyUrl = process.env.REACT_APP_INSURANCEPARAMSPROPERTY_API

export const useUrl = () => {
  const { product } = useApp()

  let url: string | undefined = ''

  switch (product) {
    case Product.TravelInsurance: url = apiTravelUrl; break;
    case Product.PropertyInsurance: url = apiPropertyUrl; break;
    default: url = apiUrl; break;
  }

  return `${baseUrl}/${url}`
}


export const useGetAll = () => {
  const url = useUrl()

  return useMutation((search: InsuranceParamsPagedQuery) =>
    axios.post<InsuranceParamsPagedGrid>(`${url}/GetList`, search))
}


export const useGetInsuranceParamsDiscounts = (
  paramsId: string,
  options?: GenericQueryOptions<InsurerDiscount[]>,
) => {
  const url = useUrl()
  return useQuery(
    ['useGetInsuranceParamsDiscounts', paramsId],
    () => {
      return axios.get<InsurerDiscount[]>(`${url}/GetDiscounts?paramsId=${paramsId}`)
    },
    options,
  )
}
export const useGetInsurersSpecificParams = (
  paramsId: string,
  insurerId: number | null,
  options?: GenericQueryOptions<IndividualDiscount[]>,
) => {
  const url = useUrl()
  return useQuery(
    ['useGetInsurersSpecificParams', paramsId, insurerId],
    () =>
      axios.get<IndividualDiscount[]>(
        `${url}/GetInsurersSpecificParams?paramsId=${paramsId}${!!insurerId ? '&insurerId=' + insurerId : ''
        }`,
      ),
    options,
  )
}

export const useCloneInsuranceParams = (paramsId: string, replacement: boolean = false) => {
  const url = useUrl()
  return useMutation({
    mutationFn: () =>
      axios.post<{ insuranceParamsId: number }>(
        `${url}/Clone?paramsId=${paramsId}&replacement=${replacement}`,
      ),
  })
}

export const useGetIpid = (paramsId: string) => {
  const url = useUrl()
  return useMutation({
    mutationFn: () => axios.post<{ ipidLink: string }>(`${url}/GetIpid?paramsId=${paramsId}`),
  })
}

export const useFindContractNumber = (
  contractNumber: string,
  insurerId: number,
  options?: GenericQueryOptions<{ insuranceParamsId?: number }>,
) => {
  const url = useUrl()
  return useQuery(
    ['useFindContractNumber', contractNumber, insurerId],
    () =>
      axios.post<{ insuranceParamsId?: number }>(
        `${url}/FindContractNumber?contractNumber=${contractNumber}&insurerId=${insurerId}`,
      ),
    options,
  )
}

export const useGetAvailableBusinessmen = (
  paramsId: string,
  options?: GenericQueryOptions<[{ id: string; fullname: string }]>,
) => {
  const url = useUrl()
  return useQuery(
    ['useGetAvailableBusinessmen', paramsId],
    () =>
      axios.post<[{ id: string; fullname: string }]>(
        `${url}/GetAvailableBusinessmen?paramsId=${paramsId}`,
      ),
    options,
  )
}

export const useDeleteInsuranceParams = () =>
  useMutation((data: { paramIds?: number[] }) =>
    axios.post<{ success: boolean; errors?: number[] }>(`${url}/DeleteInsuranceParams`, data),
  )

export const useGetInsurance = (offerId: number, options?: GenericQueryOptions<InsuranceBase>) => {
  const url = useUrl()
  return useQuery(['useGetInsurance', offerId]
    , () => axios.get<InsuranceBase>(`${url}/GetInsurance?offerId=${offerId}`)
    , options)
}

export const useGetInsurances = (offerIds: number[]) => {
  const url = useUrl()
  return useQueries(offerIds.map((id) => {
    return {
      queryKey: ['useGetInsurance', id],
      queryFn: () => axios.get<InsuranceBase>(`${url}/GetInsurance?offerId=${id}`),
      //...options // , options?: GenericQueryOptions<InsuranceBase>
    }
  }))
}